import { defineComponent as _defineComponent } from 'vue'
import { ref, PropType, onMounted } from "vue"
import { Theme } from "@/types"
import { THEMES } from "@/constants"
import { loadStripe } from "@stripe/stripe-js"
import { useEnvironment } from "@/hooks/useEnvironment"


export default /*#__PURE__*/_defineComponent({
  __name: 'StripeCardInput',
  props: {
  theme: {
    type: Object as PropType<Theme>,
    default: () => ({
      primaryColor: THEMES.PERALTA_PRIMARY,
    }),
    required: false,
  },
  title: {
    type: String,
    default: "Add payment method",
  },
  submitBtnLabel: {
    type: String,
    default: "Continue",
  },
  isSubmitting: {
    type: Boolean,
    default: false,
  },
},
  emits: ["submit"],
  setup(__props, { emit }) {


const submitting = ref(false)

const form = ref({
  cardHolderName: "",
})



const { isProduction } = useEnvironment()

const STRIPE_PK = isProduction
  ? "pk_live_vIFkc4YQZtovpaPuX7U4Npon00Q8wOVFU0"
  : "pk_test_MGo8uN4tZkxdoAQrHYW1wmrP00zQXGLgDy"

onMounted(async () => {
  const stripe = await loadStripe(STRIPE_PK)
  if (!stripe) return
  const elements = stripe.elements()

  const style = {
    base: {
      iconColor: "#ff8200",
      color: "black",
      fontWeight: "500",
      fontFamily: "inherit",
      fontSize: "16px",
      fontSmoothing: "antialiased",
      "::placeholder": {
        color: "#aab7c4",
      },
    },
    invalid: {
      color: "#ff0008",
      iconColor: "#ff0008",
    },
  }

  const cardNumber = elements.create("cardNumber", { style: style, iconStyle: "solid" })

  cardNumber.mount("#card-number-element")

  const cardCvc = elements.create("cardCvc", { style: style })

  cardCvc.mount("#card-cvc-element")

  const cardExpiry = elements.create("cardExpiry", { style: style })

  cardExpiry.mount("#card-expiry-element")

  const formElement = document.getElementById("payment-form")
  formElement?.addEventListener("submit", function (event) {
    event.preventDefault()
    submitting.value = true

    stripe.createToken(cardNumber, { name: form.value.cardHolderName }).then(function (result) {
      if (result.error) {
        const errorElement = document.getElementById("errors")
        if (!errorElement) return
        errorElement.textContent = result.error.message as string
      } else {
        emit("submit", result)
      }

      submitting.value = false
    })
  })
})

return { __sfc: true,emit, submitting, form, isProduction, STRIPE_PK }
}

})